import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { formatDate, formatMoney, getInlineLoader, setCookie } from "../Helpers";
import {
	STR_AMOUNT,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CLOSING_BALANCE,
	STR_COMMISSIONS_REPORT,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_CREATE_NEW,
	STR_DATE,
	STR_DESCRIPTON,
	STR_FLOAT,
	STR_LOGOUT,
	STR_MY_COACH,
	STR_MY_STUDENTS,
	STR_NO_RECORD,
	STR_OPENING_BALANCE,
	STR_PAYABLE,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_RECEIVABLE,
	STR_REPORT_FOR,
	STR_REPORT_TYPE,
	STR_SET_CURRENCY,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_TILL_NUMBER,
	STR_TOTAL_2,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_WHATSAPP_SETUP,
	STR_YOUR_PROFILE,
	STR_YOUR_REPORTS
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdDetails, MdInfoOutline, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSupportAgent, MdTranslate, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import { RiProfileLine } from "react-icons/ri";
import EditAgentProfile from "./EditAgentProfile";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getMyAgentReports(),
			appContext.getCurrentUserData(),
		])
		setReady(true);
	}

	function logOut() {
		appContext.setShowOverlayLoader(true);
		setCookie('userId', "", -10000000);
		setCookie('userToken', "", -10000000);
		appContext.navTo({
			item: '',
		})
		appContext.refresh();
		appContext.setShowOverlayLoader(false);
	}

	useEffect(() => {
		init();
	}, [])



	if (ready) {
		if(appContext.isAgentProfileComplete) {
			return (
				<div
					style={{
						width: "100%",
						height: "100%",
						overflow: "scroll",
						paddingTop: "20px",
						paddingBottom: "calc(var(--topBarHeight) + 40px)",
					}}
					className="mNoScrollBar"
				>
					<div className="container">

						<div className="row">

							<div className="col-md-12">
								<div className="card">
									<div className="card-body">
										<h6
											className="mSectionTitle"
											style={{
												marginTop: "0"
											}}
										>
											{STR_YOUR_REPORTS[appContext.language]}
										</h6>

										<div className="text-end">
											<button
												className="btn btn-sm btn-outline-primary"
												onClick={() => {
													appContext.navTo({
														item: 'side-view',
														subItem: 'create-agent-report'
													})
												}}
											>
												{STR_CREATE_NEW[appContext.language]}
											</button>
										</div>
									</div>
								</div>
							</div>

							<div className="col-md-12" style={{ overflow: "scroll" }}>

								<div
									style={{
										//minWidth: "600px",
									}}
								>
									<table
										className="table table-striped"
										style={{ fontSize: "14px" }}
									>
										<thead>
											<tr>
												<th >{STR_DATE[appContext.language]}</th>
												<th>{STR_TOTAL_2[appContext.language]}</th>
											</tr>
										</thead>

										<tbody>
											{
												(appContext.myAgentReports && appContext.myAgentReports.length > 0) ?
												appContext.myAgentReports.map((item, i) => {
													return (
														<tr
															key={i}
															onClick={() => {
																appContext.navTo({
																	item: 'side-view',
																	subItem: 'agent-report',
																	extraItem: item.id,
																})
															}}
														>
															<td
															>
																{formatDate(item.dateReported)}
															</td>
															
															
															<td
															>
																{formatMoney(item.totalAmount)} TZS
															</td>
															
														</tr>
													)
												})
												:
												<tr>
													<td>
														{STR_NO_RECORD[appContext.language]}
													</td>
												</tr>
											}
										</tbody>
									</table>
								</div>

							</div>

							

						</div>

					</div>


				</div>
			)
			
		} else {
			return <EditAgentProfile/>
		}
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}